import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { JackpotWinBanner } from "./JackpotWinBanner";

export class JackpotWinBannerComponent extends AbstractDisplayComponent {
    private container: Container;

    public override init() {
        const containerConfig = {
            labelName: "jp_win_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 0,
                posY: 0,
                scale: 1,
            },
            portrait: {
                posX: 0,
                posY: 0,
                scale: 1,
            },
        };

        this.container = new JackpotWinBanner(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public play(jackpotMultiplier: number, winAmount: number, callback?: () => void): void {
        (this.container as JackpotWinBanner).play(jackpotMultiplier, winAmount, callback);
    }
}
